import React, { useEffect, useState } from "react";
import CustomTable from "../../../../components/table/table";
import {
  admin_publications_list,
  admin_publications_delete,
} from "../../admin.api";
import Loader from "../../../../components/loader/loader";
import ManagePublication from "./manage/manage";
import ConfirmDialog from "../../../../components/actionDialogs/confirmDialog";
import Snackbar from "../../../../components/snackbar/snackbar";
import "./view.css";
import jwtDecode from "jwt-decode";
export default function View(props) {
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const [isActive, setIsActive] = useState(true);
  const [data, setdata] = useState([]);
  const [addNew, setAddNew] = useState(false);
  const [view, setView] = useState(false);
  const [formData, setFormData] = useState({});
  const [activeData, setActiveData] = useState({});
  const [openAction, setOpenAction] = useState(false);
  const [edit, setEdit] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [baseUrl, setBaseUrl] = useState("");

  const handleEventList = () => {
    setIsActive(true);
    admin_publications_list().then((res) => {
      setdata(res?.data);
      setBaseUrl(res?.current_url || "");
      setIsActive(false);
    });
  };
  const handleAddNew = () => {
    setAddNew(true);
    setView(false);
  };
  const handleView = (data) => {
    setFormData(data);
    setAddNew(true);
    setView(true);
  };
  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleClose = () => {
    setAddNew(false);
    setEdit(false);
    setFormData({});
    handleEventList();
  };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  const getStatusLabel = (dueDate) => {
    if (!dueDate) {
      return "-";
    }
    const parsedDueDate = new Date(dueDate);
    if (isNaN(parsedDueDate)) {
      return "-";
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    parsedDueDate.setHours(0, 0, 0, 0);

    return parsedDueDate >= today ? "Active" : "Expired";
  };
  const renderStatusPill = (dueDate) => {
    const label = getStatusLabel(dueDate);
    const type =
      label === "Active" ? "active" : label === "Expired" ? "expired" : "unknown";

    return (
      <span className={`status-pill status-pill--${type}`}>
        {label}
      </span>
    );
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    admin_publications_delete(data.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleEventList();
    }
  };
  const getFileNmae = (url) => {
    let name = null;

    name = url.substring(url.lastIndexOf("/") + 1);
    return name;
  };
  const handleEdit = (data) => {
    let d = {
      ...data,
      file_name: getFileNmae(data.upload_image),
    };
    setFormData(d);
    setView(false);
    setEdit(true);
    setAddNew(true);
  };
  const getDownloadUrl = (filePath) => {
    if (!filePath) {
      return null;
    }
    if (/^https?:\/\//i.test(filePath)) {
      return filePath;
    }
    if (baseUrl) {
      const trimmedBase = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
      const cleanedPath = filePath.startsWith("/") ? filePath.slice(1) : filePath;
      return `${trimmedBase}/${cleanedPath}`;
    }
    return filePath;
  };

  useEffect(() => {
    handleEventList();
  }, []);
  return (
    <div>
      {" "}
      <Loader open={isActive} />
      <div className="view-container">
        <h6>
          <b>Publications</b>
        </h6>
        <hr />
        {adminType != 23 && (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={(e) => handleAddNew(e)}
          >
            Add New
          </button>
        )}
        <CustomTable
          {...props}
          columns={[
            { title: "Title", field: "publication_title" },
            {
              title: "File",
              field: "upload_image",
              render: (row) => {
                const fileUrl = getDownloadUrl(row?.upload_image);
                return fileUrl ? (
                  <a href={fileUrl} download target="_blank" rel="noopener noreferrer">
                    Download
                  </a>
                ) : (
                  "-"
                );
              },
            },
            {
              title: "Link",
              field: "link",
              render: (row) =>
                row?.link ? (
                  <a href={row.link} target="_blank" rel="noopener noreferrer">
                    {row.link}
                  </a>
                ) : (
                  "-"
                ),
            },
            {
              title: "Status",
              field: "due_date",
              render: (row) => renderStatusPill(row?.due_date),
            },
          ]}
          data={data}
          actions={
            adminType === 2
              ? [
                { type: "view", handleClick: handleView },
                { type: "edit", handleClick: handleEdit },
                { type: "delete", handleClick: handleDelete },
              ]
              : adminType === 1
                ? [
                  { type: "view", handleClick: handleView },
                  { type: "edit", handleClick: handleEdit },
                  // { type: "delete", handleClick: handleDelete },
                ]
                : [
                  { type: "view", handleClick: handleView },
                  // { type: "delete", handleClick: handleDelete },
                ]
          }
        />
      </div>
      {addNew && (
        <ManagePublication
          open={addNew}
          edit={edit}
          view={view}
          handleClose={handleClose}
          formData={formData}
          baseUrl={baseUrl}
        />
      )}
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Publication ?"
          data={activeData}
          message="Are you sure to delete this publication?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
